export default __webpack_public_path__ + "static/media/img2.37fc1887.PNG";